<template>

  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              Begegnung
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <div class="submit-form">
                <div v-if="!submitted && currentMatch">

                  <div v-responsive.md.lg.xl>
                    <p>{{ currentMatch.homeTeam }} - {{ currentMatch.guestTeam }}</p>
                  </div>

                  <div v-responsive.sm.xs>

                    <div class="row col-12 div-no-wrap">
                      <div class="col-6 img-height">
                        <img :src="currentMatch.homeTeamImage" width="30px" heigth="30px"/>
                      </div>
                      <div class="col-6 img-height">
                        <img :src="currentMatch.guestTeamImage" width="30px" heigth="30px"/>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">

                    <div v-responsive.md.lg.xl class="row align-content-center">
                      <div class="col-md-4">
                        <input
                            type="tel"
                            class="form-control"
                            required
                            :disabled="isPassedTimeLimit()"
                            v-model="homeScoreValue"
                            name="home-team"/>
                      </div>
                      <div class="col-md-1">:</div>
                      <div class="col-md-4">
                        <input
                            type="tel"
                            class="form-control"
                            required
                            :disabled="isPassedTimeLimit()"
                            v-model="guestScoreValue"
                            name="guest-team"/>
                      </div>
                    </div>

                    <div v-responsive.sm.xs>
                      <div class="row col-12">
                        <div class="col-4">
                          <input
                              type="tel"
                              class="form-control"
                              required
                              :disabled="isPassedTimeLimit()"
                              style="margin-top: 5px;"
                              v-model="homeScoreValue"
                              name="home-team"/>
                        </div>
                        <div class="col-2" style="margin-top: 10px;">:</div>
                        <div class="col-4">
                          <input
                              type="tel"
                              class="form-control"
                              required
                              :disabled="isPassedTimeLimit()"
                              style="margin-top: 5px;"
                              v-model="guestScoreValue"
                              name="guest-team"/>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div v-if="showError">{{ errorMessage }}</div>

                  <div v-responsive.sm.xs>
                    <button @click="saveTip"
                            type="submit"
                            value="submit"
                            :disabled="isPassedTimeLimit()"
                            class="btn btn-sm btn-success btn-margin-sm">Speichern
                    </button>
                    <button @click="$emit('close')" class="btn btn-sm btn-info btn-margin-md">
                      Schliessen
                    </button>
                  </div>

                  <div v-responsive.md.lg.xl>
                    <button @click="saveTip"
                            type="submit"
                            value="submit"
                            :disabled="isPassedTimeLimit()"
                            class="btn btn-success btn-margin-md">Speichern
                    </button>
                    <button @click="$emit('close')" class="btn btn-info btn-margin-md">Schliessen
                    </button>
                  </div>

                </div>
              </div>

            </slot>
          </div>

        </div>
      </div>
    </div>
  </transition>

</template>

<script>
import MatchDataService from "../services/match-data.service"

export default {
  name: "create-match-tip",
  props: {
    currentMatch: Object,
    homeScore: {
      Type: Number,
      default: 0
    },
    guestScore: {
      Type: Number,
      default: 0
    }
  },
  data() {
    return {
      matchTip: {
        match_id: null
      },
      homeScoreData: {
        Type: Number,
        default: null
      },
      guestScoreData: {
        Type: Number,
        default: null
      },
      submitted: false,
      showError: false,
      errorMessage: ""
    };
  },
  methods: {
    saveTip() {
      if (this.isPassedTimeLimit()) {
        this.errorMessage = "Spiel bereits begonnen!";
        this.showError = true;
      } else {
        if (this.homeScore === null) {
          this.errorMessage = "Heimtore fehlen!";
          this.showError = true;
        } else if (this.guestScore === null) {
          this.errorMessage = "Auswärtstore fehlen!";
          this.showError = true;
        } else {
          this.showError = false;
          this.message = "";
          var data;
          if (this.currentMatch.tips.length > 0) {
            data = {
              _id: this.currentMatch.tips[0]._id,
              match_id: this.currentMatch._id,
              homeScore: this.homeScoreValue,
              guestScore: this.guestScoreValue
            };
          } else {
            data = {
              match_id: this.currentMatch._id,
              homeScore: this.homeScoreValue,
              guestScore: this.guestScoreValue
            };
          }
          MatchDataService.saveTip(data)
              .then(response => {
                this.matchTip._id = response.data._id;
                this.$emit('close');
              })
              .catch(e => {
                this.errorMessage = "Der Tipp konnte nicht gespeichert werden: " + e.message;
                this.showError = true;
                this.$emit('close');
              });
        }
      }
    },
    getMatch(id) {
      MatchDataService.getMatch(id)
          .then(response => {
            this.currentMatch = response.data;
            console.log(response.data)
          })
          .catch(e => {
            console.log(e);
          });
    },
    isMaintenance() {
      return this.$store.state.sys.isMaintenance;
    },
    isPassedTimeLimit() {
      if (this.isMaintenance()) {
        return false;
      } else if (new Date(this.currentMatch.matchDate) < Date.now()) {
        return true;
      } else {
        console.log(this.currentMatch.matchDate);
        return false;
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.submit-form {
  max-width: 300px;
  margin: auto;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 10px 15px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 10px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.btn-margin-md {
  margin: 5px;
}

.btn-margin-sm {
  margin: auto;
}

.image-fit {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.img-height {
  height: 50px;
}

.div-no-wrap {
  flex-wrap: nowrap;
}

</style>